import { useMemo } from 'react';

import { useProject } from '../services/api/KeynomeAPIHooks';
import { normalizeProjectAnalysisStatusResponse } from './analysisStatusUtils';

function getErrorMessage(error) {
  if (!error) {
    return null;
  }

  return error.message || 'The project clonality analysis status could not be loaded.';
}

export function useProjectAnalysisStatus({
  projectId,
  enabled = true,
} = {}) {
  const fetchEnabled = Boolean(enabled && projectId);
  const query = useProject(projectId, {
    queryParams: { extraFields: ['lib_seqs_awaiting_clonality_analysis'] },
    useQueryOptions: {
      enabled: fetchEnabled,
      refetchInterval: 60000,
    },
  });

  const normalizedStatus = useMemo(() => normalizeProjectAnalysisStatusResponse(fetchEnabled ? query.data : null, {
    isLoading: fetchEnabled ? query.isLoading : false,
    isError: fetchEnabled ? query.isError : false,
    errorMessage: fetchEnabled ? getErrorMessage(query.error) : null,
  }), [fetchEnabled, query.data, query.error, query.isError, query.isLoading]);

  return {
    ...normalizedStatus,
    isFetching: query.isFetching,
    refetch: query.refetch,
    rawStatus: query.data,
  };
}

export default useProjectAnalysisStatus;
